import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAccounts } from '../Contexts/Context_Accounts';
import DRLogo from '../Assets/Images/DR_Logo.png';
import REDLogo from '../Assets/Images/RED_Logo.png';
import Background from '../Assets/Images/NSDAPS_Main_Facade.png';
import { Context_UI } from '../Contexts/Context_UI';
import UI_Divider from '../components/ERUMAUI/UI_Divider';
import UI_Form from '../components/ERUMAUI/UI_Form';
import UI_Input_Text from '../components/ERUMAUI/UI_Input_Text';
import UI_Password_List from '../components/ERUMAUI/UI_Password_List';
import UI_Subwindow_Manager from '../components/ERUMAUI/UI_Subwindow_Manager';
import Subwindow_Modal_ResetPassword_Success from '../components/Subwindow_Modal_ResetPassword_Success';
import { useStatus } from '../Contexts/Context_Status_Global';

export default function DR_ResetPassword_Final() {
    const UI = useContext(Context_UI);
    const Navigate = useNavigate();
    const Location = useLocation();
    const Parameters = new URLSearchParams(Location.search);
    const Verify_Token = Parameters.get('vt');
    const { Confirmer_Confirm } = useStatus();

    const { User_Reset_Password_Verify, User_Reset_Password_Final } = useAccounts();

    const [TokenState, TokenState_Set] = useState("Verifying"); // Verifying | Valid | Invalid
    const [Message, Message_Set] = useState("Verifying token...");
    const [Loading, Loading_Set] = useState(false);

    const [Password_New, Password_New_Set] = useState("");
    const [Password_Confirm, Password_Confirm_Set] = useState("");
    const [Message_State, Message_State_Set] = useState("Inactive");

    const [Composition_Subwindow] = useState([
        { ID: "Window_ResetPassword_Success", Component: <Subwindow_Modal_ResetPassword_Success /> }
    ]);

    useEffect(() => {
        UI.Page_Navigator_Set(Navigate);
        setTimeout(() => window.LoadingScreen_Hide(), 500);

        const Verify = async () => {
            if (!Verify_Token) {
                TokenState_Set("Invalid");
                Message_Set("Missing verification token. Please request a new password reset.");
                return;
            }

            try {
                const Result = await User_Reset_Password_Verify(Verify_Token);
                if (Result === "SUCCESS") {
                    TokenState_Set("Valid");
                } else {
                    TokenState_Set("Invalid");
                    switch (Result) {
                        case "INVALIDTOKEN":
                            Message_Set("Invalid or corrupted reset link.");
                            break;
                        case "EXPIRED":
                            Message_Set("Your reset link has expired. Please request a new one.");
                            break;
                        case "ALREADYVERIFIED":
                            Message_Set("This reset link has already been used.");
                            break;
                        default:
                            Message_Set("Unable to verify token. Please try again or request a new reset link.");
                    }
                }
            } catch (err) {
                console.error(err);
                TokenState_Set("Invalid");
                Message_Set("An error occurred during verification. Please try again later.");
            }
        };

        Verify();
    }, [Verify_Token]);

    const Handle_Type = async () => {
        const Passed = await UI.Input_Evaluate([
            {
                Type: "Password_New",
                ID: "Input_Password_New",
                Indicator: "Password_New_Check"
            }
        ]);
    }

    const ResetPassword = async () => {
        const Passed = await UI.Input_Evaluate([
            {
                Type: "Text",
                ID: "Input_Password_New",
                Prompt: "This field is required."
            },
            {
                Type: "Text",
                ID: "Input_Password_New_Repeat",
                Prompt: "This field is required."
            },
            {
                Type: "Compare_Sameness",
                ID_Start: "Input_Password_New",
                ID_End: "Input_Password_New_Repeat",
                Prompt: "The passwords do not match."
            },
            {
                Type: "Password_New",
                ID: "Input_Password_New",
                Indicator: "Password_New_Check"
            }
        ]);

        if (!Passed || !Verify_Token) {
            return;
        };

        try {
            Loading_Set(true);
            Message_State_Set("Active");
            Message_Set("Resetting password...");

            const Result = await User_Reset_Password_Final(Verify_Token, Password_New);
            // console.log(Result);
            switch (Result.code) {
                case "SUCCESS":
                    Message_State_Set("Success");
                    Message_Set("Password reset successful!");
                    const { Response, Data } = await Confirmer_Confirm('Window_ResetPassword_Success');
                    if (Response === "Confirmed") {
                        Navigate("/");
                    }
                    break;
                case "INVALIDTOKEN":
                    Message_State_Set("Error");
                    Message_Set("Invalid or expired token.");
                    break;
                case "Token_Unverified":
                    Message_State_Set("Error");
                    Message_Set("Token not verified yet.");
                    break;
                case "NOTOKEN":
                    Message_State_Set("Error");
                    Message_Set("Token missing.");
                    break;
                case "EXPIRED":
                    Message_State_Set("Error");
                    Message_Set("Token expired. Please request a new one.");
                    break;
                case "ALRVERIFIED":
                    Message_State_Set("Error");
                    Message_Set("Token expired. Please request a new one.");
                    break;
                default:
                    Message_State_Set("Error");
                    Message_Set("Something went wrong. Please try again.");
            }
        } catch (err) {
            console.error(err);
            Message_State_Set("Error");
            Message_Set("An error occurred. Please try again.");
        } finally {
            Loading_Set(false);
        }
    };

    // --- UI Layout ---
    return (
        <>
            <UI_Subwindow_Manager Composition={Composition_Subwindow} />

            <div className="Landing">
                <div className="Landing_Content">
                    <div className="Landing_Logo_DR">
                        <img className="Landing_Logo_DR_Image" src={DRLogo} draggable="false" loading='lazy' alt='' />
                    </div>

                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <div className='Landing_Verify'>

                            {TokenState === "Verifying" && (
                                <>
                                    <h2 className='General_Title'>Verifying your link...</h2>
                                    <UI_Divider />
                                    <p className='General_Paragraph'>{Message}</p>
                                </>
                            )}

                            {TokenState === "Invalid" && (
                                <>
                                    <h2 className='General_Title'>Reset link invalid</h2>
                                    <UI_Divider />
                                    <p style={{ textAlign: "center" }}>{Message}</p>
                                    <button
                                        className="General_Button"
                                        style={{ marginTop: "20px" }}
                                        onClick={() => Navigate("/")}
                                    >
                                        Go back to login
                                    </button>
                                </>
                            )}

                            {TokenState === "Valid" && (
                                <>
                                    <h2 className='General_Title'>Reset your password</h2>
                                    <UI_Divider />

                                    <UI_Form Composition="ByTwo">
                                        <UI_Input_Text
                                            id="Input_Password_New"
                                            Input_Type='password'
                                            Label_Text="New password"
                                            Input_Placeholder="Type your new password"
                                            Required={true}
                                            onChange={(e) => Password_New_Set(e.target.value)}
                                            onInput={Handle_Type}
                                        />
                                        <UI_Input_Text
                                            id="Input_Password_New_Repeat"
                                            Input_Type='password'
                                            Label_Text="Confirm new password"
                                            Input_Placeholder="Re-type your new password"
                                            Required={true}
                                            onChange={(e) => Password_Confirm_Set(e.target.value)}
                                        />
                                    </UI_Form>

                                    <UI_Password_List id="Password_New_Check" />

                                    <div
                                        className='Landing_Form_Message'
                                        State={Message_State === "Active" || Message_State === "Error" || Message_State === "Success" ? "Active" : "Inactive"}
                                        Indicator={
                                            Message_State === "Error"
                                                ? "Negative"
                                                : Message_State === "Success"
                                                    ? "Positive"
                                                    : "Neutral"
                                        }
                                    >
                                        <p className='Landing_Form_Message_Text'>{Message}</p>
                                    </div>

                                    <button
                                        className="General_Button"
                                        style={{ marginTop: "10px" }}
                                        disabled={Loading}
                                        onClick={ResetPassword}
                                    >
                                        {Loading ? "Processing..." : "Reset Password"}
                                    </button>

                                    <button
                                        className="General_Button"
                                        style={{ marginTop: "10px" }}
                                        onClick={() => Navigate("/")}
                                    >
                                        Go back to login
                                    </button>
                                </>
                            )}

                        </div>
                    </div>

                    <div className="Landing_Logo_RED">
                        <img className="Landing_Logo_RED_Image" src={REDLogo} draggable="false" loading='lazy' alt='' />
                    </div>
                </div>

                <div className="Landing_Banner">
                    <img className="Landing_Banner_Image" src={Background} draggable="false" loading='lazy' alt='' />
                </div>
            </div>
        </>
    );
}
